import Simple from "../../../Components/InputFields/Simple";
import PassWord from "../../../Components/InputFields/PassWord";
import GradientBlue from "../../../Components/InputFields/GradientBlue";
import Divider from "./Divider";
import SimpleButton from "../../../Components/Buttons/Simple";
import GoogleAuthButton from "./GoogleAuthButton";
import LogoWhite10 from "../../../Media/PNG/LogoWhite10.svg";
import LogoBlue from "../../../Media/PNG/LogoBlue.svg";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getNextFromRedirect,
  getRedirectFromNext,
} from "../../../helper/nextRedirect";
import BackToHome from "./BackToHome";
import { API_BASE_URL } from "../../../config/api";
export default function Container({
  text,
  type,
  signupData,
  setSignupData,
  setStep,
}) {
  const [isDark, setIsDark] = useState(
    typeof document !== "undefined" &&
      document.documentElement.classList.contains("dark"),
  );
  const logoSrc = isDark ? LogoWhite10 : LogoBlue;
  const [hasError, setHasError] = useState(false);
  const [error, setError] = useState(false);

  const navigate = useNavigate();
  const { search } = useLocation();
  const urlRef = new URLSearchParams(search).get("ref");
  const nextParam = new URLSearchParams(search).get("next");
  const redirectFromNext = getRedirectFromNext(nextParam);
  const storedRedirect = localStorage.getItem("post_login_redirect");
  const redirectPath = redirectFromNext || storedRedirect;
  const nextForRedirect = nextParam || getNextFromRedirect(redirectPath);
  const signinHref = nextForRedirect
    ? `/SignIn?next=${nextForRedirect}`
    : "/SignIn";

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (urlRef) {
      setSignupData((pre) => ({ ...pre, referral_code: urlRef }));
    }
  }, [setSignupData, urlRef]);

  useEffect(() => {
    if (redirectFromNext) {
      localStorage.setItem("post_login_redirect", redirectFromNext);
    }
  }, [redirectFromNext]);

  const [emailBlur, setEmailBlur] = useState(false);
  const [emailValid, setEmailValid] = useState(true);
  const [passwordBlur, setPasswordBlur] = useState(false);
  const [passwordValid, setPasswordValid] = useState(true);
  const [passwordAgainBlur, setPasswordAgainBlur] = useState(false);
  const [passwordAgainValid, setPasswordAgainValid] = useState(true);
  const [referralCodeInvalid, setReferralCodeInvalid] = useState(false);

  const [fieldsRequired, setFieldsRequired] = useState(false);

  const [emailTaken, setEmailTaken] = useState(false);

  function isValidEmail(email) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }

  function isValidPassword(password) {
    // must be at least 8 characters and contain at least:
    // one lowercase letter, one uppercase letter, one number, one special character
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

    return regex.test(password);
  }

  useEffect(() => {
    if (!isValidEmail(signupData.email)) {
      setEmailValid(false);
    } else {
      setEmailValid(true);
    }

    if (!isValidPassword(signupData.password)) {
      setPasswordValid(false);
    } else {
      setPasswordValid(true);
    }

    if (signupData.password !== signupData.password_again) {
      setPasswordAgainValid(false);
    } else {
      setPasswordAgainValid(true);
    }
  }, [signupData]);

  useEffect(() => {
    setEmailTaken(false);
  }, [emailBlur]);

  const handleEmailChange = (e) => {
    setSignupData({ ...signupData, email: e.target.value });
  };
  const handleReferralCodeChange = (e) => {
    setReferralCodeInvalid(false);
    setSignupData({ ...signupData, referral_code: e.target.value });
  };
  const handlePasswordChange = (e) => {
    setSignupData({ ...signupData, password: e.target.value });
  };
  const handlePasswordAgainChange = (e) => {
    setSignupData({ ...signupData, password_again: e.target.value });
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    if (
      signupData.email === "" ||
      signupData.password === "" ||
      signupData.password_again === "" ||
      signupData.email === null ||
      signupData.password === null ||
      signupData.password_again === null ||
      signupData.email === undefined ||
      signupData.password === undefined ||
      signupData.password_again === undefined
    ) {
      setFieldsRequired(true);
      return;
    } else {
      setFieldsRequired(false);
    }
    if (!emailValid || !passwordValid || !passwordAgainValid) {
      return;
    }
    setLoading(true);
    try {
      let emailJsonBody = {
        email: signupData.email,
      };
      const response = await fetch(
        `${API_BASE_URL}auth/trader/signup/check-email/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(emailJsonBody),
        },
      );

      const result = await response.json();

      // Check if server responded with error status
      if (result.status === "failure") {
        setEmailTaken(true);
      }
      if (signupData.referral_code !== "") {
        let refJsonBody = {
          referral_code: signupData.referral_code,
        };
        const refResponse = await fetch(
          `${API_BASE_URL}auth/trader/signup/check-referral-code/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(refJsonBody),
          },
        );

        const refResult = await refResponse.json();
        if (refResult.status === "failure") {
          setReferralCodeInvalid(true);
          setLoading(false);
          return;
        }
      }
      if (result.status === "failure") {
        setLoading(false);
        return;
      }
      setLoading(false);
      setStep(2);
    } catch (error) {
      console.error("POST request failed:", error);
      setLoading(false);
      return null; // or throw error again if you want
    }
  };

  useEffect(() => {
    if (emailTaken) {
      setHasError(true);
      setError("این ایمیل قبلا ثبت نام شده است");
    } else if (!emailValid && emailBlur) {
      setHasError(true);
      setError("لطفا یک ایمیل معتبر وارد کنید");
    } else if (!passwordValid && passwordBlur) {
      setHasError(true);
      setError(
        " رمز عبور حداقل ۸ کاراکتر شامل عدد، حروف بزرگ و کوچک، کاراکتر ویژه",
      );
    } else if (!passwordAgainValid && passwordAgainBlur) {
      setHasError(true);
      setError("رمز های عبور مطابقت ندارند");
    } else if (fieldsRequired) {
      setHasError(true);
      setError("لطفا تمامی فیلدها را پر کنید");
    } else if (referralCodeInvalid) {
      setHasError(true);
      setError("کد معرف نامعتبر است");
    } else {
      setHasError(false);
    }
  }, [
    fieldsRequired,
    emailValid,
    emailBlur,
    passwordValid,
    passwordBlur,
    passwordAgainValid,
    passwordAgainBlur,
    emailTaken,
    referralCodeInvalid,
  ]);
  return (
    <div className="w-full max-w-md bg-zi-bg2-light dark:bg-zi-bg2-dark rounded-2xl p-5 m-4 gap-7 flex flex-col border border-zi-blue-light">
      <div className="flex flex-col gap-2 justify-center items-center">
        <img src={logoSrc} alt="لوگو" className="w-14" />
        <p className="font-medium text-sm text-zi-text-light dark:text-zi-text-dark">
          کوژیتو فاند
        </p>
      </div>
      <div className="flex items-center justify-between gap-3">
        <h1 className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
          {text}
        </h1>
        <BackToHome />
      </div>
      <div>
        <form className="flex flex-col gap-5" autoComplete="off">
          <Simple
            placeholder="آدرس ایمیل"
            type="email"
            id="email"
            formValue={signupData.email}
            formOnChange={handleEmailChange}
            emailBlur={emailBlur}
            setEmailBlur={setEmailBlur}
            emailValid={emailValid}
          />
          <PassWord
            placeholder="رمز عبور"
            id="password"
            svg_classname=""
            formValue={signupData.password}
            formOnChange={handlePasswordChange}
            passwordBlur={passwordBlur}
            setPasswordBlur={setPasswordBlur}
            passwordValid={passwordValid}
          />
          <PassWord
            placeholder="تکرار رمز عبور"
            id="password_again"
            svg_classname=""
            formValue={signupData.password_again}
            formOnChange={handlePasswordAgainChange}
            passwordBlur={passwordAgainBlur}
            setPasswordBlur={setPasswordAgainBlur}
            passwordValid={passwordAgainValid}
          />
          <Simple
            placeholder="کد معرف (اختیاری)"
            type="text"
            id="referral_code"
            formValue={signupData.referral_code}
            formOnChange={handleReferralCodeChange}
            readOnly={urlRef}
          />
          {!loading ? (
            <GradientBlue
              type="submit"
              value="مرحله بعدی"
              onClick={handleSignup}
            />
          ) : (
            <GradientBlue
              type="submit"
              isLoader={true}
              onClick={handleSignup}
            />
          )}
        </form>
        {hasError && (
          <p className="text-red-500 text-sm font-extralight mt-1">{error}</p>
        )}
        <Divider text="یا" />
        <GoogleAuthButton text="ثبت‌نام با گوگل" />
        <Divider text="حساب کاربری دارید؟" />
        <SimpleButton text="ورود" svg_name="" href={signinHref}></SimpleButton>
      </div>
    </div>
  );
}
